import React, { PropTypes } from 'react';
import DatePicker from 'react-pikaday-component';
import bowser from 'bowser';
import Modernizr from 'modernizr';

import './style.scss';

const DateInput = (props) => {
  const { input, className, format } = props;

  // only render date input if it is supported and the user is on a mobile or tablet device
  const shouldRenderDateInput = Modernizr.inputtypes.date && (bowser.mobile || bowser.tablet);

  return (
    <div className="DateInput">
      {shouldRenderDateInput
        ? <input
            {...input}
            className={className}
            type="date"
            id={`${input.name}`}
          />
        : <DatePicker
            {...input}
            className={className}
            value={new Date(input.value)}
            format={format}
            yearRange={[
              (new Date()).getFullYear() - 30,
              (new Date()).getFullYear()
            ]}
            maxDate={new Date()}
            id={`${input.name}`}
          />
      }
    </div>
  );
};

DateInput.propTypes = {
  input: PropTypes.object,
  format: PropTypes.string,
  className: PropTypes.string
};

export default DateInput;





/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/DateInput/index.js
 **/